       
              <div class="cardBox mb-20">

                <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">
                  <!-- Job Score -->
                  <ion-col size="12" size-sm="3" >
                      <span class="jobScoreTitle">Avg Reactive Job Score :  <span class="jobScoreNum">30</span></span>
                    
                  </ion-col>
                  <!-- Year Select -->
                  <ion-col size="12" size-sm="3" class=" ml-sm-20 mt-sm-20">
                    <mat-form-field class="custom-mat-field mat-height40 mat-input-style w-100">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                                  (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                        <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                          {{ sharedService.transformYearToFyFormat(item.year) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                      <!-- Program Select -->
                      <ion-col size="12" size-sm="3" class=" ml-sm-20 mt-sm-20">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <mat-select placeholder="Select Program">
                            <mat-option *ngFor="let program of programList" [value]="program">
                              {{ program }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ion-col>
    
                      <!-- Employee Multi-select -->
                      <ion-col size="12" size-sm="3" class=" ml-sm-20 mt-sm-20">
                        <ng-multiselect-dropdown 
                          class="w-100 mat mat-height40 mat-input-style"
                          [placeholder]="'Select Employee'"
                          [settings]="dropdownSettings"
                          [data]="getEmployeeList"      
                          (onSelect)="onEmployeeSelect()"
                          (onDeSelect)="onEmployeeDeSelect()"
                          (onSelectAll)="onEmployeeAllSelect()"
                          (onDeSelectAll)="onEmployeeAllDeSelect()">
                        </ng-multiselect-dropdown>
                      </ion-col>
                    </ion-row>
    
                    <hr style="border: none; height: 1px; background-color: #cccccc8f;" />
               
                    
                <ion-row class="ion-align-items-center ion-justify-content-between ml-20">
                  <ion-col size="12" size-lg="9">
                    <ion-row class="ion-align-items-center">
                      <!-- Search -->
                      <ion-col size="12" size-sm="4" >
                        <mat-form-field class="mat-height40 mat-input-style w-100">
                          <mat-icon matPrefix>search</mat-icon>
                          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                        </mat-form-field>
                      </ion-col>
                    </ion-row>
                  </ion-col>

                  <ion-col size="12" size-lg="3" >
                    <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
                      <label>
                        <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                        <mat-form-field class="w70px mat-height40 mat-input-style">
                          <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                            <mat-option [value]="2">2</mat-option>
                            <mat-option [value]="25">25</mat-option>
                            <mat-option [value]="50">50</mat-option>
                            <mat-option [value]="75">75</mat-option>
                            <mat-option [value]="100">100</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                      </label>
                      <!-- Download Icon -->
                      <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
                    </div>
                  </ion-col>

                </ion-row>

            
                <div class="p-10">
                  <ion-row>
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  
                      <div class="table-container">
                        <table  class="custom-table rounded-header">
                          <thead>
                            <tr>
                              <th>Program Title</th>
                              <th>Emp Code</th>
                              <th>Emp Name</th>
                              <th>Q1</th>
                              <th>Q2</th>
                              <th>Q3</th>
                              <th>Avg Score by Employee</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let emp of trainingScores; let i = index">
                              <td>Program</td>
                              <td>{{ emp.empCode }}</td>
                              <td>{{ emp.empName }}</td>
                              <td *ngFor="let score of emp.scores">{{ score }}</td>
                              <td>{{ getEmployeeAverage(emp.scores) }}</td>
                              <!-- <td *ngIf="i === 0" [attr.rowspan]="trainingScores.length+1">
                                {{ getProgramAverage() }}
                              </td> -->
                            </tr>
                      
                            <!-- Row for average score per question -->
                            <tr>
                              <td colspan="3"><b>Avg. question score</b></td>
                              <td *ngFor="let avg of getQuestionAverages()"><b>{{ avg }}</b></td>
                              <td></td>
                         
                            </tr>
                      
                          
                          </tbody>
                        </table>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            